import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { func } from "../../../utils";
import { SwooshSVG } from "../../JadwalPertandingan/JadwalPertandingan.styled";
import { Loading } from "../../../components";

import Section from "../../../components/atoms/Section";
import useWindowSize from "../../../hooks/useWindowSize";
import { ContentWrapper, InnerContentWrapper } from "./FaseKnockoutSOC.styled";
import GroupTable from "./components/KnockoutTable";
import dummyData from "./dummy-data.json";
import KnockoutTable from "./components/KnockoutTable";
import {
  useFetchClassmentsDetails,
  useFetchClassmentsDetailsV2,
  useFetchKnockoutBracket,
  useFetchRegionEventSeries,
} from "../../../networks";
import { restructureToKnockoutArray } from "./helper";

const FaseKnockoutSOC = ({ activeClassLevel }) => {
  const { city } = useParams();
  const { search } = useLocation();

  const activeCardType =
    new URLSearchParams(search).get("activeCard") === "futsalsmpGroup" ? 2 : 1;
  const isSMP = activeClassLevel?.toLowerCase() === "smp";
  const [activeCarousel, setActiveCarousel] = useState(activeCardType);
  const { size } = useWindowSize();

  const { data: dataRaw } = useFetchRegionEventSeries();

  const dataRegistCity = dataRaw?.data?.data?.eventSeries || [];

  const dataCityAttribute = dataRegistCity?.find(
    (val) =>
      String(val?.region_name)?.toLowerCase() === String(city)?.toLowerCase()
  );
  const dataCityAttributeId = dataCityAttribute?.id;

  const { data: dataKnockoutBracketRaw, isFetching } = useFetchKnockoutBracket(
    dataCityAttributeId,
    dataCityAttribute?.length
  );

  console.log({
    dataKnockoutBracketRaw: dataKnockoutBracketRaw?.data?.data,
    dataCityAttributeId,
  });
  const dataClassmentsDetail =
    restructureToKnockoutArray(
      dataKnockoutBracketRaw?.data?.data || [],
      `futsal${activeClassLevel}`
    ) ?? [];

  const dataKnockout = dataClassmentsDetail || [];

  console.log({ dataKnockout });
  const isMobileView = (size?.width || 0) <= 830;

  // Check if "Fase Knockout" exists, then find the "Champion" round
  // const championRound = dataKnockout?.rounds
  //   ? dataKnockout?.rounds?.flat().find((round) => round.round_name === "Final")
  //   : null;

  // const hasFinalPlayed =
  //   championRound?.club1?.winner || championRound?.club2?.winner;

  // const winningClub = championRound?.club1?.winner
  //   ? championRound?.club1?.name
  //   : championRound?.club2?.winner
  //   ? championRound?.club2?.name
  //   : null;

  // const losingClub = !championRound?.club1?.winner
  //   ? championRound?.club1?.name
  //   : !championRound?.club2?.winner
  //   ? championRound?.club2?.name
  //   : null;

  const thirdPlaceRound = dataKnockout?.rounds
    ? dataKnockout?.rounds
        ?.flat()
        .find((round) => round.round_name === "Third Place")
    : null;

  // const hasThirdPlacePlayed =
  //   thirdPlaceRound?.club1?.winner || thirdPlaceRound?.club2?.winner;

  // const winningThirdPlaceClub = thirdPlaceRound?.club1?.winner
  //   ? thirdPlaceRound?.club1?.name
  //   : thirdPlaceRound?.club2?.winner
  //   ? thirdPlaceRound?.club2?.name
  //   : null;

  const championRound = dataKnockout?.rounds
    ? dataKnockout?.rounds
        ?.flat()
        .find((round) => round.round_name === "Champion")
    : null;
  console.log({ championRound });
  const firstPlace = championRound?.club_1st
    ? championRound?.club_1st.name
    : null;

  const secondPlace = championRound?.club_2nd
    ? championRound?.club_2nd.name
    : null;
  const thirdPlace = championRound?.club_3rd
    ? championRound?.club_3rd.name
    : null;

  const fourthPlace = championRound?.club_4th
    ? championRound?.club_4th.name
    : null;
  console.log({ fourthPlace });
  const fourthPlaceHome = thirdPlaceRound?.home_club
    ? thirdPlaceRound?.home_club?.name
    : null;

  if (isFetching) return <Loading />;
  console.log({ dataKnockout });
  return (
    <>
      <Section id="klasemen-pertandingan" height={"auto"} overflowY={"auto"}>
        <ContentWrapper style={{ marginTop: 0 }}>
          <InnerContentWrapper>
            <div className="flex lg:flex-row flex-col">
              <div className="flex flex-col  md:flex-row ">
                <KnockoutTable data={dataKnockout} />
              </div>
              {isMobileView && (
                <div className="flex flex-row items-center">
                  <img
                    src={func.getStaticImg(`icon/notes-red.svg`)}
                    alt="notes"
                    className="w-[12px] h-[12px] mt-3 mr-2"
                  />
                  <span className="text-[#DDE2E8] text-[16px] flex flex-row items-center mt-3">
                    Menang melalui adu pinalti
                  </span>
                </div>
              )}
              <div className="relative flex items-center flex-col gap-4 bottom-0 md:bottom-72">
                <div className="relative flex flex-col">
                  <img
                    className="relative w-[234px] h-[256px] right-6"
                    src={func.getStaticImg("/illustration/piyu-soc.png")}
                  ></img>
                  <img
                    className="relative w-[123px] h-[21px] mx-auto bottom-2 left-2"
                    src={func.getStaticImg("/illustration/winner-soc.png")}
                  ></img>
                </div>
                <div className="flex items-center w-[234px] h-[42px] rounded-full bg-[#f18729] overflow-hidden">
                  <div
                    className="bg-white w-[44px] h-full flex items-center justify-center"
                    style={{
                      clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
                    }}
                  >
                    <span className="text-[#222d3c] font-bold">1</span>
                  </div>
                  <div className="bg-[#f18729] flex-1 h-full flex items-center">
                    <span className="font-bold text-[16px]/[18px] text-white">
                      {/* {hasFinalPlayed ? winningClub : "Juara 1"} */}
                      {firstPlace !== null &&
                      firstPlace !== "TBD" &&
                      championRound?.club_1st?.position !== "TBD"
                        ? firstPlace
                        : "Juara 1"}
                    </span>
                  </div>
                </div>
                <div className="flex items-center w-[234px] h-[42px] rounded-full bg-[#f18729] overflow-hidden">
                  <div
                    className="bg-white w-[44px] h-full flex items-center justify-center"
                    style={{
                      clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
                    }}
                  >
                    <span className="text-[#222d3c] font-bold text-2xl">2</span>
                  </div>
                  <div className="bg-[#f18729] flex-1 h-full flex items-center">
                    <span className="font-bold text-[16px]/[18px] text-white">
                      {/* {hasFinalPlayed ? losingClub : "Juara 2"} */}
                      {secondPlace !== null &&
                      secondPlace !== "TBD" &&
                      championRound?.club_2nd?.position !== "TBD"
                        ? secondPlace
                        : "Juara 2"}
                    </span>
                  </div>
                </div>
                <div className="flex items-center w-[234px] h-[42px] rounded-full bg-[#f18729] overflow-hidden">
                  <div
                    className="bg-white w-[44px] h-full flex items-center justify-center"
                    style={{
                      clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
                    }}
                  >
                    <span className="text-[#222d3c] font-bold text-2xl">3</span>
                  </div>
                  <div className="bg-[#f18729] flex-1 h-full flex items-center">
                    <span className="font-bold text-[16px]/[18px] text-white">
                      {/* {hasThirdPlacePlayed ? winningThirdPlaceClub : "Juara 3"} */}
                      {thirdPlace !== null && thirdPlace !== "TBD"
                        ? thirdPlace
                        : "Juara 3"}
                    </span>
                  </div>
                </div>

                {isSMP ? (
                  <div className="flex items-center w-[234px] h-[42px] rounded-full bg-[#f18729] overflow-hidden">
                    <div
                      className="bg-white w-[44px] h-full flex items-center justify-center"
                      style={{
                        clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
                      }}
                    >
                      <span className="text-[#222d3c] font-bold text-2xl">
                        3
                      </span>
                    </div>
                    <div className="bg-[#f18729] flex-1 h-full flex items-center">
                      <span className="font-bold text-[16px]/[18px] text-white">
                        {fourthPlace !== null && fourthPlace !== "TBD"
                          ? fourthPlace
                          : "Juara 3"}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center w-[234px] h-[42px] rounded-full bg-[#f18729] overflow-hidden">
                    <div
                      className="bg-white w-[44px] h-full flex items-center justify-center"
                      style={{
                        clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
                      }}
                    >
                      <span className="text-[#222d3c] font-bold text-2xl">
                        3
                      </span>
                    </div>
                    <div className="bg-[#f18729] flex-1 h-full flex items-center">
                      <span className="font-bold text-[16px]/[18px] text-white">
                        {fourthPlace !== null && fourthPlace !== "TBD"
                          ? fourthPlace
                          : "Juara 3"}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {!isMobileView && (
              <div className="flex flex-row items-center">
                <img
                  src={func.getStaticImg(`icon/notes-red.svg`)}
                  alt="notes"
                  className="w-[12px] h-[12px] mt-3 mr-2"
                />
                <span className="text-[#DDE2E8] text-[16px] flex flex-row items-center mt-3">
                  Menang melalui adu pinalti
                </span>
              </div>
            )}
          </InnerContentWrapper>
        </ContentWrapper>
      </Section>
    </>
  );
};

export default FaseKnockoutSOC;
